import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Auth } from "aws-amplify";
import { compose } from "redux";
import cx from "classnames";
import _ from "lodash";

import eventsImg from "assets/images/events.svg";
import logo from "assets/images/heylime-logo.png";
import toggleIcon from "assets/images/toggle-bar.svg";
import activityImg from "assets/images/activities.svg";
import reportingImg from "assets/images/reporting.svg";
import challangesImg from "assets/images/challanges.svg";
import myteamWhite from "assets/images/sideBarTabs/myteamWhite.png";
import eventsWhite from "assets/images/sideBarTabs/eventsWhite.png";
import myTeamBlack from "assets/images/sideBarTabs/myTeamBlack.png";
import reportingWhite from "assets/images/sideBarTabs/reportingWhite.png";
import activitiesWhite from "assets/images/sideBarTabs/activitiesWhite.png";
import challengesWhite from "assets/images/sideBarTabs/challengesWhite.png";
import * as gameAction from "redux/game/action";
import * as loaderAction from "redux/loader/action";
import * as webUrlAction from "redux/webUrl/action";
import * as signInAction from "redux/signin/action";
import * as paramsAction from "redux/gameParams/actions";

const SideBarTabs = (props) => {
  const { history, current_user, handleOptClick } = props;
  const url = window.location.pathname;

  const team = _.get(current_user, "team");
  var cognitoUser = Auth.userPool.getCurrentUser();

  const onLogOut = async () => {
    sessionStorage.clear();
    props.setIsLoading(true);
    localStorage.removeItem("utm_medium");
    localStorage.removeItem("utm_source");
    localStorage.removeItem("utm_campaign");
    localStorage.removeItem("utm_content");
    localStorage.removeItem("webUrl");
    localStorage.removeItem("viewer");
    localStorage.removeItem("setwebUrl");
    props.setViewerWebUrl(false);
    localStorage.removeItem("temp_utm_source");
    localStorage.removeItem("temp_utm_content");
    localStorage.removeItem("temp_utm_medium");
    localStorage.removeItem("temp_utm_campaign");
    sessionStorage.removeItem("gameCode");
    localStorage.removeItem("work_game");
    localStorage.removeItem("mailId");
    sessionStorage.removeItem("teamCode");
    sessionStorage.removeItem("trailSocialLogin");
    props.setGameName("");
    props.endGame(true);
    props.emptyGameData({});
    props.setIsLoading(true);
    props.setCurrentUser({});
    props.set_sign_in_details({ sign_up: false, sign_up_with_email: false });
    localStorage.removeItem("auth");
    await Auth.signOut()
      .then((user) => {
        props.endGame(true);
        props.setCurrentUser({});
        props.setIsLoading(false);
        history.push("/signup");
      })
      .catch((err) => {});
  };

  const handleMyTeamClick = () => {
    if (cognitoUser !== null && current_user?.team !== undefined) {
      history.push("/my-team");
    } else {
      history.push("/no-team");
    }
  };

  const handleTeamReports = () => {
    if (cognitoUser !== null && current_user?.team !== undefined) {
      history.push("/team-reports");
    } else {
      history.push("/no-team");
    }
  };

  const handleHomeClick = () => {
    var cognitoUser = Auth.userPool.getCurrentUser();
    if (cognitoUser !== null && current_user?.team !== undefined) {
      history.push("/");
    } else {
      history.push("/no-team");
    }
  };

  const handleActivitiesClick = () => history.push("/activities");

  const handleChallengesClick = () => {
    if (history.location.pathname.includes("team-challenges")) {
      history.push("challenges-library");
    } else {
      history.push("team-challenges/challenges-library");
    }
  };

  return (
    <aside className="sidebar-container">
      <div
        onClick={() => history.push("/")}
        className="sidebar-container__logo"
      >
        <img src={toggleIcon} className="img-fluid toggle" alt="toggleIcon" />
        <img src={logo} className="img-fluid logo" alt="logo" />
      </div>
      <div className="sidebar-container__tabs">
        <div
          onClick={handleHomeClick}
          className={cx("tab-item", {
            active: ["/game-library", "/"].includes(url)
          })}
        >
          <img
            src={
              ["/game-library", "/"].includes(url)
                ? activitiesWhite
                : activityImg
            }
            alt="activityImg"
          />
          <p
            className={cx("name", {
              activeName: ["/game-library", "/"].includes(url)
            })}
          >
            Home
          </p>
        </div>

        <div
          onClick={handleActivitiesClick}
          className={cx("tab-item", {
            active: url.includes("/activities")
          })}
        >
          <img
            src={url.includes("/activities") ? activitiesWhite : activityImg}
            alt="activityImg"
          />
          <p
            className={cx("name", {
              activeName: url.includes("/activities")
            })}
          >
            Activities
          </p>
        </div>
        <div
          onClick={handleChallengesClick}
          className={cx("tab-item", {
            active: url.includes("/team-challenges")
          })}
        >
          <img
            src={
              url.includes("/team-challenges") ? challengesWhite : challangesImg
            }
            alt="activityImg"
          />
          <p
            className={cx("name", {
              activeName: url.includes("/team-challenges")
            })}
          >
            Challenges
          </p>
        </div>
        <div
          onClick={handleOptClick}
          className={cx("tab-item", {
            active: url.includes("/outside_team_building")
          })}
        >
          <img
            src={
              url.includes("/outside_team_building") ? eventsWhite : eventsImg
            }
            alt="activityImg"
          />
          <p
            className={cx("name", {
              activeName: url.includes("/outside_team_building")
            })}
          >
            Events
          </p>
        </div>
        <div
          onClick={handleTeamReports}
          className={cx("tab-item", {
            active: url.includes("/team-reports")
          })}
        >
          <img
            src={url.includes("/team-reports") ? reportingWhite : reportingImg}
            alt="activityImg"
          />
          <p
            className={cx("name", {
              activeName: url.includes("/team-reports")
            })}
          >
            Reporting
          </p>
        </div>
        <div
          onClick={handleMyTeamClick}
          className={cx("tab-item", {
            active: url.includes("/my-team")
          })}
        >
          <img
            alt="activityImg"
            src={url.includes("/my-team") ? myteamWhite : myTeamBlack}
          />
          <p
            className={cx("name", {
              activeName: url.includes("/my-team")
            })}
          >
            My Team
          </p>
        </div>
      </div>
      <div className="invite">
        <ul>
          {!_.isEmpty(current_user) && (
            <li
              className={cx("list-item", {
                active: url.includes("/account")
              })}
              onClick={() => history.push("/account")}
            >
              Account
            </li>
          )}
          {!_.isEmpty(team) && (
            <li
              className={cx("list-item", {
                active: url.includes("/billing")
              })}
              onClick={() => history.push("/billing")}
            >
              Billing
            </li>
          )}
          {!_.isEmpty(team) && (
            <li
              className="list-item"
              onClick={() => history.push("/invite_teammates")}
            >
              Invite
            </li>
          )}
          {cognitoUser !== null ? (
            <li className="list-item" onClick={onLogOut}>
              Log Out
            </li>
          ) : (
            <li className="list-item" onClick={() => history.push("/signup")}>
              Sign in
            </li>
          )}
        </ul>
      </div>
    </aside>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
  setViewerWebUrl: (data) => dispatch(webUrlAction.setViewerWebUrl(data)),
  setGameName: (data) => dispatch(gameAction.setGameName(data)),
  endGame: (data) => dispatch(gameAction.endGame(data)),
  emptyGameData: (data) => dispatch(paramsAction.emptyGameData(data)),
  setCurrentUser: (data) => dispatch(gameAction.setCurrentUser(data)),
  set_sign_in_details: (data) =>
    dispatch(signInAction.set_sign_in_details(data))
});

export default compose(
  withRouter,
  connect(null, mapDispatchToProps)
)(SideBarTabs);
